(function ($) {
    "use strict";

    $(function () {
        function formatPmCounterNumber(num, isFloat) {
            var formattedNumber = isFloat ? parseFloat(num.toFixed(2)) : Math.round(num);
            return new Intl.NumberFormat('hu-HU').format(formattedNumber);
        }

        function animatePmCounter(counter, targetValue, duration) {
            var startTime = null;
            var isFloat = Math.floor(targetValue) !== targetValue;

            function step(timestamp) {
                if (!startTime) startTime = timestamp;
                var progress = timestamp - startTime;
                var now = Math.min(progress / duration, 1) * targetValue;

                counter.textContent = formatPmCounterNumber(now, isFloat);

                if (progress < duration) {
                    requestAnimationFrame(step);
                }
            }

            requestAnimationFrame(step);
        }

        var pmCounters = document.querySelectorAll(".js-pm-counters");

        if (!pmCounters.length) return;

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.intersectionRatio > 0) {
                    entry.target.querySelectorAll(".js-pm-counter").forEach(function (counter) {
                        var numberEl = counter.querySelector(".js-pm-counter__number");
                        var targetValue = parseFloat(numberEl.textContent.replace(/\s/g, '').replace(',', '.'));
                        animatePmCounter(numberEl, targetValue, 5000);
                    });

                    observer.unobserve(entry.target);
                }
            });
        });

        pmCounters.forEach(function (counters) {
            observer.observe(counters);
        });

        if (window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
            document.querySelectorAll(".js-pm-counter").forEach(function (item) {
                item.addEventListener("mouseenter", function () {
                    item.classList.add("is-pulsing");
                });

                item.addEventListener("animationend", function (event) {
                    var valueEl = item.querySelector(".pm-counters__value");

                    if (event.animationName === "pm-counters-pulse" && event.target === valueEl) {
                        item.classList.remove("is-pulsing");
                    }
                });
            });
        }
    });
})(jQuery);
